<template>
  <div class="partnerPortal">
    <div class="login">
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        class="demo-ruleForm"
      >
        <el-form-item label="Email" prop="userName">
          <el-input
            v-model.trim="loginForm.userName"
            placeholder="Input your email: e.g. john@sangfor.com"
            auto-complete="on"
          ></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="Password">
          <el-input
            v-model="loginForm.Password"
            placeholder="Your Password"
            :type="passw"
            @keyup.enter.native="submitForm('loginForm')"
          >
            <svg-icon
              slot="suffix"
              v-if="!this.showPassword"
              @click.native="handlePassword"
              icon-class="hidPassword"
            />
            <svg-icon
              slot="suffix"
              v-else
              @click.native="handlePassword"
              icon-class="showPassword"
            />
          </el-input>
        </el-form-item>
        <el-form-item label="Verification Code"
                        prop="VerificationCode"
                        class="validCode">
            <el-input class="input" v-model="loginForm.VerificationCode"
                      @keyup.enter.native="submitForm('loginForm')">
              <template slot="append">
                <img :src="validCodeUrl"
                     alt="Code"
                     @click="getValidCode">
              </template>
            </el-input>
          </el-form-item>
        <el-checkbox
        v-model="readPrivacyPolicy"
        style="margin-bottom: 24px"
        class="checkbox"
        >I have read and agree to the</el-checkbox
      >
      <a style="color: #3e84e9" @click.stop="showPrivacyPolicy = true"
        >Privacy Policy</a
      >
        <el-form-item class="loginBtnBox">
          <div class="loginBut">
            <el-button
              type="primary"
              :disabled="!readPrivacyPolicy"
              @click="submitForm('loginForm')"
              :loading="isLogin"
              >Login</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="Privacy Policy"
      :visible.sync="showPrivacyPolicy"
      width="1200px"
      top="50px"
    >
      <div>
        <p style="color:#666666; word-break: break-word; font-size:15px; line-height:26px;">SANGFOR attach great importance to the security of your Personal Data（as defined hereinafter）seriously. Collecting, using, storing of your personal data may be conducted upon you visit this https://knowledgebase.sangfor.com  (<span style="font-size:11pt; font-weight: bold; color: rgb(102, 102, 102);">“Sangfor Knowledge Base”</span>) based on your consent, contract relationship or any applicable legal ground. This Privacy Policy represents how we collect, use, store your Personal Data as well as your legitimate rights to access, update, delete, and protect your Personal Data in relation to this Sangfor Knowledge Base.</p><br/>
        <p style="color:#666666; word-break: break-word; font-size:15px; line-height:26px;">Considering Sangfor provides various kinds of products and services, this Privacy Policy may not cover all possible scenarios for personal data processing. Any specific data relating to the processing of personal data in the context of Sangfor’s products or services may be described in the privacy policy of related products or services, or may be released in any notice that is given during the collection of data.</p><br/>
        <p style="color:#666666; word-break: break-word; font-weight: bold; line-height:26px; font-size: 11pt;">YOU ARE REQUIRED TO GET FULLY UNDERSTANDING OF THIS PRIVACY POLICY BEFORE SUBMITTING YOUR PERSONAL DATA TO SANGFOR. BY USING THIS SANGFOR KNOWLEDGE BASE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD AND AGREE TO ALL OF THE TERMS OF THIS PRIVACY POLICY.</p><br>
        <p style="color:#666666; word-break: break-word; font-size:15px; line-height:26px;">We use the following definitions in this Privacy Policy:</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;"><span style="font-weight: bold;">· “Sangfor”, “we”, “us”</span> means Sangfor Technologies Inc. and/or its affiliates. </p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;"><span style="font-weight: bold;">· “Personal Data”</span> means any information relating to an identified or identifiable natural person (“data subject”); an identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;"><span style="font-weight: bold;">· “you”</span> means the users of this Sangfor Knowledge Base.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;"><span style="font-weight: bold;">· “Sangfor Knowledge Base”</span> means a self-service online library where you can find the most recent information you may need to help you better understand Sangfor products & solutions.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">1. Collection and Use of Personal Data</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">Your Personal Data maybe be collected by your behavior of using this Sangfor Knowledge Base, registering relevant accounts or interacting with us. We may collect the following personal data about you:</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">(1) Information provided by you to Sangfor</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">This includes information about you that you provide to us. By using this Sangfor Knowledge Base, you need to log in to enjoy certain functions or services. When you log in this Sangfor Knowledge Base, we will ask you to provide the corresponding personal information, including: </p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">· your e-mail address,employee ID, password, your first name, last name, mobile /fix-line telephone number, user login account name, password, address details, company name, country, etc.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">· any information that you choose to share on this Sangfor Knowledge Base or when you contact us which may be considered Personal Data.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">We use your above Personal Data for the purposes of completing your login of Sangfor Knowledge Base, and providing corresponding service for you, including:</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">· Providing search knowledge service.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">· Other service to you.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">(2) Information that we collect or generate about you.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">By using cookie and other similar technologies, this Sangfor Knowledge Base may indirectly record your personal data. When you use this Sangfor Knowledge Base, we may collect certain data automatically from your computers or devices (including mobile devices). The data we collect automatically may include:</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">· your IP address, device type, operating system, unique device identifiers, browser-type, browser language, geographic location and other technical information.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">· the pages viewed, the links clicked, the amount of time spent on particular pages, mouse hovers, the date and time of the interaction, error logs, referring and exit pages and URLs, and similar information.</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">We use this information only for our analytical purposes, and to improve the quality, relevance, and security of Sangfor Knowledge Base.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">Should the purposes of using your personal data are not included in this Privacy Policy, we will obtain your prior consent before we implementing the relevant purpose. Moreover, you are entitled to withdraw your consent at any time in compliance with the laws and regulations, but this maybe cause the function limitation of this Sangfor Knowledge Base. </p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">2. Cookies and Other Similar Technologies</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">Like most sites, we use technologies that are essentially small data files placed on your computer, tablet, mobile phone, or other devices (referred to collectively as a "device") that allow us to record certain pieces of data whenever you visit or interact with this Sangfor Knowledge Base, and to recognize you across devices. </p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">The specific names and types of the cookies, unique identifiers, and similar technologies we use to collect data (e.g. about the pages you view, the links you click, and other actions you take on in this Sangfor Knowledge Base) may change from time to time. In order to help you better understand this Privacy Policy and our use of such technologies we have provided the following limited terminology and definitions: </p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">Cookies – Small text files (typically made up of letters and numbers) placed in the memory of your browser or device when you visit a website or view a message. Cookies allow a website to recognize a particular device or browser. </p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">Similar technologies – Technologies that store personal data in your browser or device utilizing local shared objects or local storage, such as flash cookies, HTML 5 cookies, and other web application software methods. These technologies can operate across all of your browsers, and in some instances may not be fully managed by your browser and may require management directly through your installed applications or device. We do not use these technologies for storing personal data to target advertising to you on or off our sites.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">We may use the terms "cookies" or "similar technologies" interchangeably in our policies to refer to all technologies that we may use to store data in your browser or device or that collect data or help us identify you in the manner described above.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">3. Rights to Your Personal Data</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">If you submit your Personal Data to us, please ensure the accuracy of such data. If your Personal Data has changed (for instance, your mobile phone number has been changed), you are obliged to update your personal data in a timely manner.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">For requirements by applicable laws, you may: (1) have access to your Personal Data we have held; (2) update or correct any of your inaccurate Personal Data; (3) restrict or object to allow us to process your Personal Data; (4) require us to erasure your Personal Data;(5) require us to comply with your request for data portability; (6) withdraw your consent at any time which will not affect the lawfulness of processing based on consent before ;(7) lodge a complaint with the corresponding supervisory authority.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">When you claim the said rights, we may require you to submit a written request and may verify your identify. Usually, we do not charge anything for such processes unless your request goes beyond the limit of conventional requirements.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">4.  Protection and Storage of Personal Data</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">We recognize the need to ensure that personal information gathered via this Sangfor Knowledge Base remains secure. Sangfor Knowledge Base has security measures in place to protect against the loss, misuse, and alteration of the personal information under our control. Our security measures include the use of a hardware firewall to prevent unauthorized access, access control, allocate system privileges, data transmission and storage encryption, data backup on EU cloud server. You acknowledge that although we exercise adequate care and security, there remains a risk that information transmitted over the Internet and stored by computer may be intercepted or accessed by an unauthorized third-party. We will retain your information for the period necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">5.  Breach Notification</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">In line with the GDPR, where a breach is known to have occurred which is likely to result in a risk to the rights and freedoms of individuals, the relevant Data Protection Authority (DPA) will be informed within 72 hours, unless the personal data breach is unlikely to result in a risk to the rights and freedoms of natural persons. Where the notification to the supervisory authority is not made within 72 hours, Sangfor inform the supervisory authority of the reasons for the delay. This will be managed in accordance with our Information Security Incident Response Procedure which sets out the overall process of handling information security incidents.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">6.  Update of this Privacy Policy</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">This Privacy Policy may be modified from time to time in line with legislation or industry developments. We therefore advise you to check this Privacy Policy regularly. Any material changes will be notified via this Sangfor Knowledge Base, email or other means we deem appropriate.</p><br>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt; font-weight: bold;">7.  Contact Us</p>
        <p style="color:#666666; word-break: break-word; line-height:26px; font-size: 11pt;">If you have any further question about this Privacy Policy, or have any request or query for your Personal Data, you can always contact us by e-mail: marketing@sangfor.com.</p><br>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { encrypt, emailEncrypt } from "./../utils/secureUtil";
import { loginPp,getPpuserInfo,sendEmail } from "./../api/login";
export default {
  inject:['reload'],
  data() {
    var checkEmail = (rule, value, callback) => {
      const mailReg =
        /^([a-zA-Z0-9._-]+[_|\_|\.]?)*[a-zA-Z0-9._-]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!value) {
        return callback(new Error("Email is required."));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("Please enter the correct email format"));
        }
      }, 100);
    };
    var checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("The password cannot be empty"));
      } else {
        callback();
      }
    };
    var checkVerificationCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("The verification code cannot be empty"));
      } else {
        callback();
      }
    };
    return {
      num:'',
      validCodeUrl: '',
      readPrivacyPolicy: false,
      showPrivacyPolicy: false,
      timesOut: 59,
      isLogin: false,
      isTimeOut: false,
      passw: "password",
      showPassword: false,
      loginForm: {
        userName: "",
        Password: "",
        VerificationCode: "",
      },
      rules: {
        userName: [{ validator: checkEmail, trigger: "blur" }],
        Password: [{ validator: checkPassword, trigger: "blur" }],
        VerificationCode: [
          { validator: checkVerificationCode, trigger: "click" },
        ],
      },
    };
  },
  methods: {
    //获取图形验证码
    getValidCode () {
       this.num = "";
      for (let i = 0; i < 4; i++) {
        this.num += parseInt(Math.random() * 10);
      }
      
      this.validCodeUrl =
        process.env.VUE_APP_BASE_URL + "api-auth/validate/createCode/" + this.num;
    },
    submitForm(formName) {
      if (!this.readPrivacyPolicy) return;
      this.isLogin = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let field = {};
          field.loginCode = encrypt({
            username: this.loginForm.userName,
            password: this.loginForm.Password,
          });
          field.codes=this.loginForm.VerificationCode;
          field.deviceId = this.num
          loginPp(field).then(res=>{
            this.isLogin = false;
            console.log(res);
            localStorage.setItem("readPrivacyPolicy", 0);
            localStorage.setItem('library_token', res.data.access_token)
            getPpuserInfo().then(res=>{
              localStorage.setItem('library_userInfo',JSON.stringify(res.data.user))
              this.$store.commit('SET_USERINFO',res.data.user)
              if(this.$route.params.url){
                // this.reload();
                location.href =this.$route.params.url
              }else{
                var url = "http://" + location.host + "/";
                location.href = url;
              }
            })
          }).catch(()=>{
            this.getValidCode()
            this.isLogin = false;
          })
        }
      });
    },
    //发送邮件验证码倒计时
    countdown() {
      const TIME_COUNT = 59;
      if (!this.timer) {
        this.timesOut = TIME_COUNT;
        this.isTimeOut = true;
        this.timer = setInterval(() => {
          if (this.timesOut > 1 && this.timesOut <= TIME_COUNT) {
            this.timesOut--;
          } else {
            this.isTimeOut = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    handlePassword() {
      if (this.passw == "password") {
        this.passw = "text";
        this.showPassword = true;
      } else {
        this.passw = "password";
        this.showPassword = false;
      }
    },
  },
  mounted(){
    if (localStorage.getItem("readPrivacyPolicy")) {
      this.readPrivacyPolicy = true;
    }
  },
  created(){
    this.getValidCode()
  }
  
};
</script>

<style scoped lang="scss">
.partnerPortal {
  height: 100%;
  .demo-ruleForm ::v-deep .el-form-item__label {
    width: 100%;
    text-align: left;
    font-size: 16px;
  }
  .demo-ruleForm ::v-deep .el-input__inner {
    border: 0;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0;
  }
  ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #2D2F36;
    margin-right: 5px;
  }
  ::v-deep .el-checkbox__label{
    color: #2D2F36;
    margin-right: 5px;
  }
  .loginBut {
    width: 200px;
  }
  .validCode {
    position: relative;
    .message-label{
      position: absolute;
      top: 40px;
      right: 0;
      line-height: 18px;
      text-align: right;
    }
    ::v-deep .el-input-group {
      line-height: 0;
    }
    ::v-deep .el-input-group__append {
      padding: 0;
      border: 0;
      cursor: pointer;
    }
    ::v-deep .el-input__inner{
      min-height: 35px;
    }
  }
}
</style>
